import React from "react";
import AppTemplate from "../components/ReservationCancelLogin";

const ReservationCancelLogin: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default ReservationCancelLogin;
